import type { ShopProduct } from '@/hooks/useShopProducts';

/**
 * Check if a product requires age verification
 * Returns true if product category is 'wine' OR manually flagged as age-restricted
 */
export function isAgeRestrictedProduct(product: ShopProduct): boolean {
  return product.category === 'wine' || product.isAgeRestricted === true;
}

/**
 * Get the image URL for a shop product
 * Returns local public folder path - images are served directly from public/shop/
 */
export function getProductImageUrl(product: ShopProduct): string {
  // Build the path from imagePath and optional imageFile
  const relativePath = product.imageFile 
    ? `${product.imagePath}${product.imageFile}`
    : product.imagePath;
  
  // Return the path as-is - the public folder is served at root
  // Browsers handle Hebrew characters correctly when URL-encoded
  return relativePath;
}
